/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Byty_A_DomyInputs */

const cs_enum_byty_a_domy = /** @type {(inputs: Enum_Byty_A_DomyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Byty a domy`)
};

const en_enum_byty_a_domy = /** @type {(inputs: Enum_Byty_A_DomyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Byty a domy`)
};

/**
* | output |
* | --- |
* | "Byty a domy" |
*
* @param {Enum_Byty_A_DomyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_byty_a_domy = /** @type {((inputs?: Enum_Byty_A_DomyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Byty_A_DomyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_byty_a_domy(inputs)
	return cs_enum_byty_a_domy(inputs)
});